module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// ./node_modules/sockjs-client/lib/transport/browser/eventsource.js
// module id = Qc9T
// module chunks = 0